import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';
import { ClientRender } from '@change-corgi/core/react/ssr/render';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { ResponsiveBox } from 'src/app/pages/petitionGamma/details/shared/components';

import { PetitionUrlQRCode as PetitionUrlQRCodeSunrise } from '../QRCodeSunrise';

import { ShareLoader } from './ShareLoader';

export function SharePetition() {
	return (
		<div className="px-0" data-qa="share-section-sunrise">
			<Text variant="heading" size="large">
				<Translate value="corgi.petition_gamma.share.title" />
			</Text>
			<div className="mt-6 flex flex-col gap-4 md:flex-row md:gap-6">
				<ClientRender placeholder={<Loader size="s" mt={64} mx="auto" />}>
					<PetitionUrlQRCodeSunrise />
				</ClientRender>
				<div className="w-full">
					<ResponsiveBox viewportSize="small">
						<ShareLoader forMobileView />
					</ResponsiveBox>
					<ResponsiveBox viewportSize="normal">
						<ShareLoader forMobileView={false} />
					</ResponsiveBox>
				</div>
			</div>
		</div>
	);
}
